(function ($) {
  "use strict";

  var magnificPopupUrl = window.stardrixMagnificPopupUrl;
  var magnificPopupAbsoluteUrl = magnificPopupUrl ? new URL(magnificPopupUrl, document.baseURI).href : '';
  var initializedMagnificGalleries = new WeakSet();
  var initializedMagnificIframeTriggers = new WeakSet();
  var pendingMagnificActivation = null;
  var magnificFailureLogged = false;
  var magnificIntentSelector = '.zoom, .full-view, .product_img_top a, .play-button, .popup-vimeo, .popup-gmaps';
  var magnificIframeSelector = '.play-button, .popup-vimeo, .popup-gmaps';
  var deferredProductMediaSelector = 'img[data-product-media-src], img[data-product-media-srcset]';
  var deferredProductContentSelector = 'img[data-product-content-src], img[data-product-content-srcset]';
  var boundProductMediaSwipers = new WeakSet();
  var initializedProductContentImages = new WeakSet();
  var productContentObserver = null;

  function elementsWithin(root, selector) {
    var scope = root || document;
    var elements = [];
    if (scope.matches && scope.matches(selector)) {
      elements.push(scope);
    }
    if (scope.querySelectorAll) {
      elements = elements.concat(Array.prototype.slice.call(scope.querySelectorAll(selector)));
    }
    return elements;
  }

  function hydrateDeferredProductImage(image, namespace) {
    var hydratedAttribute = 'data-' + namespace + '-hydrated';
    var srcsetAttribute = 'data-' + namespace + '-srcset';
    var srcAttribute = 'data-' + namespace + '-src';
    if (!image || image.getAttribute(hydratedAttribute) === 'true') {
      return false;
    }

    var srcset = image.getAttribute(srcsetAttribute);
    var src = image.getAttribute(srcAttribute);
    if (!srcset && !src) {
      return false;
    }

    image.setAttribute(hydratedAttribute, 'true');
    image.loading = 'eager';
    if (srcset) {
      image.setAttribute('srcset', srcset);
      image.removeAttribute(srcsetAttribute);
    }
    if (src) {
      image.setAttribute('src', src);
      image.removeAttribute(srcAttribute);
    }
    return true;
  }

  function hydrateProductMediaImage(image) {
    return hydrateDeferredProductImage(image, 'product-media');
  }

  function hydrateProductContentImage(image) {
    return hydrateDeferredProductImage(image, 'product-content');
  }

  function hydrateProductMediaWithin(container) {
    if (!container) {
      return;
    }

    if (container.matches && container.matches(deferredProductMediaSelector)) {
      hydrateProductMediaImage(container);
    }
    if (container.querySelectorAll) {
      Array.prototype.forEach.call(container.querySelectorAll(deferredProductMediaSelector), hydrateProductMediaImage);
    }
  }

  function hydrateProductMediaSlide(swiper, index) {
    if (!swiper || !swiper.slides || index < 0 || index >= swiper.slides.length) {
      return;
    }
    hydrateProductMediaWithin(swiper.slides[index]);
  }

  function hydrateActiveAndNextProductMedia(swiper) {
    var activeIndex = Number(swiper && swiper.activeIndex) || 0;
    hydrateProductMediaSlide(swiper, activeIndex);
    hydrateProductMediaSlide(swiper, activeIndex + 1);
  }

  function bindProductMediaSwiper(root) {
    var swiper = root && root.swiper;
    if (!swiper || boundProductMediaSwipers.has(swiper)) {
      return Boolean(swiper);
    }

    boundProductMediaSwipers.add(swiper);
    swiper.on('touchStart', function () {
      hydrateActiveAndNextProductMedia(swiper);
    });
    swiper.on('slideChangeTransitionStart', function () {
      hydrateActiveAndNextProductMedia(swiper);
    });
    return true;
  }

  function productMediaSwiperRoots(root) {
    return elementsWithin(root, '.swiper').filter(function (swiperRoot) {
      return Boolean(swiperRoot.querySelector(deferredProductMediaSelector));
    });
  }

  function bindProductMediaSwipers(root, attempt) {
    var roots = productMediaSwiperRoots(root);
    var waiting = roots.some(function (swiperRoot) {
      return !bindProductMediaSwiper(swiperRoot);
    });

    if (waiting && (attempt || 0) < 50) {
      setTimeout(function () {
        bindProductMediaSwipers(root, (attempt || 0) + 1);
      }, 100);
    }
  }

  function hydrateProductMediaTarget(swiperRoot, index) {
    if (!swiperRoot) {
      return;
    }

    bindProductMediaSwiper(swiperRoot);
    if (swiperRoot.swiper) {
      hydrateProductMediaSlide(swiperRoot.swiper, index);
      return;
    }

    var slides = swiperRoot.querySelectorAll('.swiper-slide');
    hydrateProductMediaWithin(slides[index]);
  }

  function handleProductMediaIntent(event) {
    var target = event.target instanceof Element ? event.target : event.target && event.target.parentElement;
    var productSection = target && target.closest('.product-details-page');
    if (!productSection) {
      return;
    }

    var thumbnailSlide = target.closest('.slider-small .swiper-slide[data-layout="thumb-slider"]');
    if (thumbnailSlide) {
      var bigGallery = productSection.querySelector('.slider-big');
      var targetIndex = Number(thumbnailSlide.getAttribute('data-index')) - 1;
      if (bigGallery && targetIndex >= 0) {
        hydrateProductMediaTarget(bigGallery, targetIndex);
        setTimeout(function () {
          bindProductMediaSwipers(productSection);
        }, 0);
      }
      return;
    }

    var swiperRoot = target.closest('.swiper');
    if (swiperRoot && swiperRoot.querySelector(deferredProductMediaSelector)) {
      bindProductMediaSwiper(swiperRoot);
      if (swiperRoot.swiper) {
        hydrateActiveAndNextProductMedia(swiperRoot.swiper);
      }
      return;
    }

    var deferredImage = target.closest(deferredProductMediaSelector);
    if (deferredImage) {
      hydrateProductMediaImage(deferredImage);
    }
  }

  function observeStaticProductMedia(productSection, mainImage) {
    var swiperRoot = mainImage.closest('.swiper');
    if (swiperRoot || !('IntersectionObserver' in window)) {
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          return;
        }
        hydrateProductMediaImage(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '200px 0px' });

    Array.prototype.forEach.call(productSection.querySelectorAll(deferredProductMediaSelector), function (image) {
      observer.observe(image);
    });
  }

  function scheduleIdleProductMedia(productSection, mainImage) {
    var hydrateNextProductMedia = function () {
      var swiperRoot = mainImage.closest('.swiper');
      if (swiperRoot) {
        bindProductMediaSwiper(swiperRoot);
        if (swiperRoot.swiper) {
          hydrateProductMediaSlide(swiperRoot.swiper, (Number(swiperRoot.swiper.activeIndex) || 0) + 1);
        } else {
          hydrateProductMediaWithin(swiperRoot.querySelectorAll('.swiper-slide')[1]);
        }
        return;
      }

      hydrateProductMediaImage(productSection.querySelector(deferredProductMediaSelector));
    };

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(hydrateNextProductMedia, { timeout: 1500 });
    } else {
      setTimeout(hydrateNextProductMedia, 200);
    }
  }

  function initializeProductMediaHydration(root) {
    var scope = root || document;
    bindProductMediaSwipers(scope);
    elementsWithin(scope, '.product-details-page').forEach(function (productSection) {
      var mainImage = productSection.querySelector(
        'img.product-featured-media[loading="eager"], .product_img_top img[loading="eager"][fetchpriority="high"]'
      );
      if (!mainImage || !productSection.querySelector(deferredProductMediaSelector)) {
        return;
      }

      var afterMainImage = function () {
        observeStaticProductMedia(productSection, mainImage);
        scheduleIdleProductMedia(productSection, mainImage);
      };
      if (mainImage.complete && mainImage.naturalWidth > 0) {
        afterMainImage();
      } else {
        mainImage.addEventListener('load', afterMainImage, { once: true });
      }
    });
  }

  function initializeProductContentHydration(root) {
    var images = elementsWithin(root, deferredProductContentSelector).filter(function (image) {
      if (initializedProductContentImages.has(image)) {
        return false;
      }
      initializedProductContentImages.add(image);
      return true;
    });
    if (!images.length) {
      return;
    }

    if (!('IntersectionObserver' in window)) {
      images.forEach(hydrateProductContentImage);
      return;
    }

    var observingStarted = false;
    var startObserving = function () {
      if (observingStarted) {
        return;
      }
      observingStarted = true;
      if (!productContentObserver) {
        productContentObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
              return;
            }
            hydrateProductContentImage(entry.target);
            productContentObserver.unobserve(entry.target);
          });
        }, {
          rootMargin: '600px 0px',
          threshold: 0
        });
      }
      images.forEach(function (image) {
        productContentObserver.observe(image);
      });
    };

    var mainImage = document.querySelector(
      '.product-details-page img.product-featured-media[loading="eager"], .product-details-page .product_img_top img[loading="eager"][fetchpriority="high"]'
    );
    if (!mainImage || (mainImage.complete && mainImage.naturalWidth > 0)) {
      startObserving();
      return;
    }

    mainImage.addEventListener('load', startObserving, { once: true });
    window.addEventListener('scroll', startObserving, { once: true, passive: true });
  }

  function initializeProductImageHydration(root) {
    initializeProductMediaHydration(root);
    initializeProductContentHydration(root);
  }

  ['pointerdown', 'touchstart', 'click'].forEach(function (eventName) {
    document.addEventListener(eventName, handleProductMediaIntent, {
      capture: true,
      passive: eventName === 'touchstart'
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeProductImageHydration(document);
    }, { once: true });
  } else {
    initializeProductImageHydration(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeProductImageHydration(event.target);
  });

  function isMagnificPopupReady() {
    return Boolean($.fn && typeof $.fn.magnificPopup === 'function');
  }

  function elementsWithin(root, selector) {
    var elements = [];

    if (root instanceof Element && root.matches(selector)) {
      elements.push(root);
    }
    if (root && root.querySelectorAll) {
      elements = elements.concat(Array.prototype.slice.call(root.querySelectorAll(selector)));
    }

    return elements;
  }

  function restoreMagnificTriggerFocus() {
    var trigger = this.stardrixReturnFocus;
    this.stardrixReturnFocus = null;

    if (trigger && trigger.isConnected && typeof trigger.focus === 'function') {
      trigger.focus({ preventScroll: true });
    }
  }

  function imagePopupOptions() {
    return {
      delegate: 'a',
      type: 'image',
      showCloseBtn: true,
      closeBtnInside: false,
      midClick: true,
      tLoading: 'Loading image #%curr%...',
      mainClass: 'mfp-img-mobile',
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0, 1]
      },
      callbacks: {
        afterClose: restoreMagnificTriggerFocus
      }
    };
  }

  function iframePopupOptions() {
    return {
      tClose: 'Close (Esc)',
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false,
      callbacks: {
        afterClose: restoreMagnificTriggerFocus
      }
    };
  }

  function galleryHasPopupImages(gallery) {
    if (gallery.querySelector('.full-view')) {
      return true;
    }

    return Array.prototype.some.call(gallery.querySelectorAll('a'), function (anchor) {
      return anchor.matches('.full-view') || Boolean(anchor.querySelector('.zoom, .full-view'));
    });
  }

  function initializeMagnificPopups(root) {
    if (!isMagnificPopupReady()) {
      throw new Error('Magnific Popup was not registered.');
    }

    elementsWithin(root || document, '.product_img_top').forEach(function (gallery) {
      if (initializedMagnificGalleries.has(gallery) || !galleryHasPopupImages(gallery)) {
        return;
      }

      $(gallery).magnificPopup(imagePopupOptions());
      initializedMagnificGalleries.add(gallery);
    });

    var iframeTriggers = elementsWithin(root || document, magnificIframeSelector).filter(function (trigger) {
      return !initializedMagnificIframeTriggers.has(trigger);
    });

    iframeTriggers.forEach(function (trigger) {
      $(trigger).magnificPopup(iframePopupOptions());
      initializedMagnificIframeTriggers.add(trigger);
    });
  }

  function findMagnificScript() {
    return Array.prototype.find.call(document.scripts, function (script) {
      return script.hasAttribute('data-stardrix-magnific-popup') || script.src === magnificPopupAbsoluteUrl;
    });
  }

  function loadMagnificPopup(root) {
    if (isMagnificPopupReady()) {
      initializeMagnificPopups(root || document);
      return Promise.resolve();
    }

    if (!magnificPopupUrl) {
      return Promise.reject(new Error('Magnific Popup asset URL is unavailable.'));
    }

    if (!window.stardrixMagnificPopupPromise) {
      window.stardrixMagnificPopupPromise = new Promise(function (resolve, reject) {
        var script = findMagnificScript();

        function handleLoad() {
          if (isMagnificPopupReady()) {
            resolve();
          } else {
            reject(new Error('Magnific Popup loaded without registering its jQuery plugin.'));
          }
        }

        function handleError() {
          reject(new Error('Magnific Popup script failed to load.'));
        }

        if (script) {
          script.addEventListener('load', handleLoad, { once: true });
          script.addEventListener('error', handleError, { once: true });
          return;
        }

        script = document.createElement('script');
        script.src = magnificPopupUrl;
        script.async = true;
        script.setAttribute('data-stardrix-magnific-popup', '');
        script.addEventListener('load', handleLoad, { once: true });
        script.addEventListener('error', handleError, { once: true });
        document.head.appendChild(script);
      })
        .then(function () {
          initializeMagnificPopups(document);
        })
        .catch(function (error) {
          if (!magnificFailureLogged) {
            magnificFailureLogged = true;
            console.error('Magnific Popup initialization failed:', error);
          }
          throw error;
        });
    }

    return window.stardrixMagnificPopupPromise.then(function () {
      initializeMagnificPopups(root || document);
    });
  }

  function findMagnificIntent(target) {
    if (!(target instanceof Element) || !target.closest(magnificIntentSelector)) {
      return null;
    }

    var iframeTrigger = target.closest(magnificIframeSelector);
    if (iframeTrigger) {
      return {
        type: 'iframe',
        trigger: iframeTrigger,
        root: iframeTrigger,
        index: 0
      };
    }

    var marker = target.closest('.zoom, .full-view');
    var anchor = target.closest('.product_img_top a');
    var gallery = null;

    if (marker) {
      gallery = marker.closest('.product_img_top');
      anchor = marker.closest('a') || anchor;
    } else if (anchor && !anchor.matches('.full-view') && !anchor.querySelector('.zoom, .full-view')) {
      return null;
    }

    if (!gallery && anchor) {
      gallery = anchor.closest('.product_img_top');
    }
    if (!gallery) {
      return null;
    }

    if (!anchor) {
      anchor = gallery.querySelector('.swiper-slide-active a') || gallery.querySelector('a');
    }

    var anchors = Array.prototype.slice.call(gallery.querySelectorAll('a'));
    var index = anchors.indexOf(anchor);
    if (!anchor || index < 0) {
      return null;
    }

    return {
      type: 'image',
      trigger: anchor,
      root: gallery,
      index: index
    };
  }

  function rememberMagnificFocus(trigger) {
    if ($.magnificPopup && $.magnificPopup.instance) {
      $.magnificPopup.instance.stardrixReturnFocus = trigger;
    }
  }

  function openMagnificIntent(intent) {
    if (!intent.trigger.isConnected || !intent.root.isConnected) {
      return;
    }

    rememberMagnificFocus(intent.trigger);
    if (intent.type === 'image') {
      $(intent.root).magnificPopup('open', intent.index);
    } else {
      $(intent.trigger).magnificPopup('open', 0);
    }
  }

  function primeMagnificPopup(event) {
    var intent = findMagnificIntent(event.target);
    if (!intent) {
      return;
    }

    loadMagnificPopup(intent.root).catch(function () {
      // The shared loader reports the error once and remains rejected to avoid retry loops.
    });
  }

  function handleMagnificClick(event) {
    var intent = findMagnificIntent(event.target);
    if (!intent) {
      return;
    }

    if (isMagnificPopupReady()) {
      initializeMagnificPopups(intent.root);
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    if (pendingMagnificActivation) {
      return;
    }

    pendingMagnificActivation = intent;
    loadMagnificPopup(intent.root)
      .then(function () {
        var queuedIntent = pendingMagnificActivation;
        pendingMagnificActivation = null;
        if (queuedIntent) {
          openMagnificIntent(queuedIntent);
        }
      })
      .catch(function () {
        pendingMagnificActivation = null;
      });
  }

  if (magnificPopupUrl) {
    ['pointerenter', 'focusin', 'pointerdown', 'touchstart'].forEach(function (eventName) {
      document.addEventListener(eventName, primeMagnificPopup, { capture: true, passive: true });
    });
    document.addEventListener('click', handleMagnificClick, true);
    document.addEventListener('shopify:section:load', function (event) {
      if (isMagnificPopupReady()) {
        initializeMagnificPopups(event.target);
      }
    });

    window.stardrixMagnificPopupLoader = {
      load: loadMagnificPopup,
      initialize: initializeMagnificPopups
    };
  }

  jQuery(document).ready(function() {
    // menu toggler js
    $("button.navbar-toggle").on('click', function() {
      $(".main-menu-area").addClass("active");
      $(".mm-fullscreen-bg").addClass("active");
      $("body").addClass("ov-hidden");
    });
    $(".close-box").on('click', function() {
      $(".main-menu-area").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $("body").removeClass("ov-hidden");
    });
    // filter button js
    $("button.filter-button").on('click', function() {
      $(".filter-sidebar").addClass("active");
      $(".mm-fullscreen-bg").addClass("active");
    });
    $("button.close-filter-sidebar").on('click', function() {
      $(".filter-sidebar").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
    });
    // body background color js
    $(".mm-fullscreen-bg").on('click',function() {
      $(".main-menu-area").removeClass("active");
      $(".filter-sidebar").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $("body").removeClass("hidden");
    });
    $('.checkout-btn .read-agree').on('click', function () {
      if($('.cust-checkbox').is(':checked')) {
        $('.checkout-btn button.check-btn').removeAttr('disabled');
      }
      else {
        $('.checkout-btn button.check-btn').attr('disabled', 'disabled');
      }
    });
    $('.read-agree').on('click', function () {
      if($('.create-checkbox').is(':checked')) {
        $('.create').removeAttr('disabled');
      }
      else {
        $('.create').attr('disabled', 'disabled');
      }
    });
    
    // Load product zoom backgrounds on first desktop hover
    $(document).on('pointerenter', '.zoom', function(event) {
      var pointerType = event.originalEvent && event.originalEvent.pointerType;

      if (pointerType !== 'mouse' && pointerType !== 'pen') {
        return;
      }

      var zoomer = this;
      var zoomImage = zoomer.getAttribute('data-zoom-image');

      if (!zoomImage || zoomer.getAttribute('data-zoom-loading') === 'true' || zoomer.getAttribute('data-zoom-loaded') === 'true') {
        return;
      }

      zoomer.setAttribute('data-zoom-loading', 'true');

      var zoomLoader = new Image();
      zoomLoader.onload = function() {
        zoomer.style.backgroundImage = 'url("' + zoomImage + '")';
        zoomer.classList.add('zoom-image-ready');
        zoomer.setAttribute('data-zoom-loaded', 'true');
        zoomer.removeAttribute('data-zoom-loading');
      };
      zoomLoader.onerror = function() {
        zoomer.removeAttribute('data-zoom-loading');
      };
      zoomLoader.src = zoomImage;
    });

    $('.item-data').on("click", function() {
      $(this).parents('.option-block').find(".variant-option").removeClass('active-variant');
      $(this).closest('form-wrap').addClass('active-variant');
      var it_img = $(this).attr('dataimg');
      $(this).parents('.single-product-wrap').find('.product-image .img1 img').attr('src',it_img);
      $(this).parents('.single-product-wrap').find('.product-image .img1 img').attr('srcset',it_img);
      var price = $(this).attr('dataprice');
      var compareprice = $(this).attr('datacompare');
      var stocks = $(this).attr('dataavailable');
      $(this).parents('.single-product-wrap').find('.price-box .new-price').text(Shopify.formatMoney(price, window.money_format));
      if (compareprice > price) {
        $(this).parents('.single-product-wrap').find('.price-box .old-price').show();
        $(this).parents('.single-product-wrap').find('.price-box .old-price').html(Shopify.formatMoney(compareprice, window.money_format));
      }else{
        $(this).parents('.single-product-wrap').find('.price-box .old-price').hide();
      }
    });
    var swiper = new Swiper('.drawer-slider', {
      slidesPerView: 1,
      grid: {
        rows: 1,
        fill: 'row' | 'column',
      },
      spaceBetween: 30,
      navigation: {
        nextEl: '.arrow-next-drawer',
        prevEl: '.arrow-prev-drawer',
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      speed: 1000,
    });
  });
})(jQuery);
